import axios from 'axios';

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getCountryCode() {
    const baseUrl = process.env.VUE_APP_BB_GEOIP_API;
    return apiClient.get(baseUrl);
  },

  getCountryList() {
    const baseUrl = process.env.VUE_APP_BB_COUNTRIES_API;
    return axios.create().get(baseUrl);
  },

  getAllEvents() {
    const baseUrl = process.env.VUE_APP_BB_ALLEVENTS_API;
    return apiClient.get(baseUrl);
  },

  getEvents() {
    const baseUrl = process.env.VUE_APP_BB_EVENTS_API;
    return apiClient.get(baseUrl);
  },

  deleteEvent(id) {
    const baseUrl = process.env.VUE_APP_BB_EVENTS_API;
    return apiClient.delete(baseUrl + id);
  },

  addEvent(obj) {
    const baseUrl = process.env.VUE_APP_BB_EVENTS_API;
    return apiClient.post(baseUrl, obj);
  },

  updateEvent(id, obj) {
    const baseUrl = process.env.VUE_APP_BB_EVENTS_API;
    return apiClient.put(baseUrl + id, obj);
  },

  getSites() {
    const baseUrl = process.env.VUE_APP_BB_SITES_API;
    return apiClient.get(baseUrl);
  },

  deleteSite(id) {
    const baseUrl = process.env.VUE_APP_BB_SITES_API;
    return apiClient.delete(baseUrl + id);
  },

  addSite(obj) {
    const baseUrl = process.env.VUE_APP_BB_SITES_API;
    return apiClient.post(baseUrl, obj);
  },

  updateSite(id, obj) {
    const baseUrl = process.env.VUE_APP_BB_SITES_API;
    return apiClient.put(baseUrl + id, obj);
  },

  getCourses() {
    const baseUrl = process.env.VUE_APP_BB_COURSES_API;
    return apiClient.get(baseUrl);
  },

  deleteCourse(id) {
    const baseUrl = process.env.VUE_APP_BB_COURSES_API;
    return apiClient.delete(baseUrl + id);
  },

  addCourse(obj) {
    const baseUrl = process.env.VUE_APP_BB_COURSES_API;
    return apiClient.post(baseUrl, obj);
  },

  updateCourse(id, obj) {
    const baseUrl = process.env.VUE_APP_BB_COURSES_API;
    return apiClient.put(baseUrl + id, obj);
  }
};
